import { createApi } from "@reduxjs/toolkit/query/react";
import { baseCustomFetchBase } from "../service/customFetchBase";

export interface CompanyInvoice {
  uuid: string;
  number: string;
  type: string;
  status: string;
  amount: number;
  totalAmount: number | null;
  currency: string | null;
  taxPercentage: number | null;
  taxAmount: number | null;
  discountPercentage: number | null;
  discountAmount: number | null;
  year: number | null;
  month: number | null;
  paidAt: string | null;
  publicNotes: string | null;
  createdAt: string | null;
  hasPdf: boolean;
}

export interface InvoicePdf {
  binary: string;
  mimetype: string;
}

const invoiceApi = createApi({
  reducerPath: "form/invoiceApi",
  baseQuery: baseCustomFetchBase,
  endpoints: (builder) => ({
    getInvoices: builder.mutation<CompanyInvoice[], void>({
      query: () => ({
        url: "company/invoices",
        method: "GET",
      }),
    }),
    getInvoicePdf: builder.mutation<InvoicePdf, string>({
      query: (id) => ({
        url: `company/invoice/${id}/invoice-pdf`,
        method: "GET",
      }),
    }),
  }),
});

export default invoiceApi;

export const { getInvoices, getInvoicePdf } = invoiceApi.endpoints;
